import { template } from "babel-core";

// zn.js
export default {
  message: {
    commonUsage: {
      confirm: "确定",
      cancel: "取消",
      edit: "编辑",
      delete: "删除",
      save: "保存",
      yes: "是",
      no: "否",
      search: "查询",
      deleteConfirmMsg: "确认删除?",
      pauseConfirmMsg: "确认暂停?",
      cacelpauseConfirmMsg: "确认取消暂停",
      addConfirmTitle: "确认保存",
      addConfirmContent: "是否确认保存?",
      delConfirmContent: "是否确认删除?",
      cancelDelMsg: "取消删除操作！",
      next: "下一步",
      previous: "上一步",
      close: "关闭",
      total: "共",
      records: "条",
      successfullySaved: "保存成功！",
      failedSaved: "保存失败！",
      successfullyAdd: "添加成功！",
      deleteSuccess: "删除成功！",
      auditSuccess: "审核成功！",
      cancelAudited: "已取消审核",
      runed: "已启动",
      paused: "已暂停",
      stoped: "已终止",
      year: "年",
      month: "月",
      day: "日",
      operation: "操作",
      province: "省",
      city: "市",
      region: "区",
      detail: "详情",
      pause: "暂停",
      pause1: "停用",
      copy: "复制",
      top: "置顶",
      notTop: "取消置顶",
      remark: "备注",
      clearFilter: "清空筛选条件",
      type: "类型",
      status: "状态",
      export: "导出",
      unit: "单位",
      add: "添加",
      operator: "操作人",
      image: "图片",
      noLimit: "无限制",
      fixedDate: "固定日期",
      relativeDate: "相对日期",
      relativeTime: "相对时间",
      piece: "张",
      refresh: "刷新",
      download: "下载",
      uploadFile: "上传文件",
      serialNumber: "序号",
      audit: "审核",
      cancelAudit: "取消审核",
      run: "启动",
      stop: "终止",
      back: "返回列表",
      tip: "提示",
      detailAddress: "详细地址",
      createTime: "创建时间",
      startTime: "开始时间",
      endTime: "结束时间",
      explanation: "说明",
      way: "方式",
      mobile: "电话",
      email: "电子邮箱",
      mail: "邮件",
      sms: "短信",
      conditions: "条件",
      clickToUpload: "点击上传",
      upload: "上传",
      uploadSuccess: "上传成功",
      uploadFail: "上传失败",
      uploading: "上传中",
      reset: "重置",
      preview: "预览",
      template: "模板",
      subject: "主题",
      today:'今天',
      sunday:'日',
      monday:'一',
      tuesday:'二',
      wednesday:'三',
      thursday:'四',
      friday:'五',
      saturday:'六',
      disable: "禁用",
      enable: "启用",
    },
    loginPage: {
      loginBtn: "登录",
      logOut: "退出登录",
chooseAnotherAccount: "您当前已使用一个账户登录，是否要退出并使用其他账户登录？",
      usernameTip: "请输入邮箱!",
      passwordTip: "请输入密码!",
      passwordCharacters: "密码不能少于8位",
      passwordFormat:
        "确认密码应该是数字、大小写字母、特殊字符的组合,请重新输入",
      username: "用户名",
      password: "密码",
      loginFailed: "登录失败",
      loginFailedMsg: "用户名或密码错误",
      loginFailedMsg1: "用户名不能为空",
      changePassword: "修改密码",
      oldPassword: "原密码",
      newPassword: "新密码",
      confirmPassword: "确认密码",
      oldPasswordTip: "请输入原密码!",
      newPasswordTip: "请输入新密码!",
      confirmPasswordTip: "请输入确认密码!",
      oldPasswordCharacters: "原密码不能少于8位",
      newPasswordCharacters: "新密码不能少于8位",
      confirmPasswordCharacters: "确认密码不能少于8位",
      passwordFormatError: "密码格式错误",
      confirmPasswordError: "确认密码与新密码不一致",
      passwordChangeSuccess: "密码修改成功",
      passwordChangeFailed: "密码修改失败",
      passwordChangeFailedMsg: "原密码错误",
      passwordChangeFailedMsg1: "新密码与原密码一致",
      passwordChangeFailedMsg2: "新密码与确认密码不一致",
    },
    header: {
      styleName: "自定义",
      style1: "自定义风格",
      style2: "标准风格",
      style3: "自定义风格2",
      changePassword: "修改密码",
      changeTimezone: "修改时区",
      subscriptionList: "订阅列表",
      signOut: "登出账号",
      language: "语言",
      chinese: "中文",
      english: "英文",
    },
    customGroup: {
      title1: "数据分析",
      title2: "自定义人群",
      title3: "人数",
      title4: "人群名称",
      title5: "人群ID",
      title6: "查询人数",
      title7: "保存",
      title8: "请填写内容",
      SaveAudience: "保存人群",
      SaveCombineAudience: "保存子人群",
      Cancel: "取消",
      Save: "保存",
      UserCount: "用户数",
      people: "人",
      CalculationType: "计算类型",
      Dynamic: "动态",
      Static: "静态",
      DynamicTip: "每日更新用户数，推荐用于监测人群趋势。",
      StaticTip: "维持人群对应用户，每日仅更新标签数据，推荐用于固定人群分析。",
      AudienceIDGenerate: "人群ID生成",
      Manually: "手动",
      Autogen: "自动生成",
      AudienceIDRange: "人群ID范围",

      FillinAudienceName: "请填写人群名称",
      SelectCalculationType: "请选择计算类型",
      SelectAudienceIDGenerationMethod: "请选择人群ID生成方式",
      FillintheAudienceID: "请填写人群ID",
      TheTotalAudienceCountIs: "人群总数为",
    },
    noPermissionPage: {
      title: "暂无权限",
    },
    addUserGroup: {
      AudienceExploration: "人群探索",
      FilterExploration: "筛选探索",
      softLabel: "软标签",
      SelectLabel: "请选择标签",
      SelectCalculationRule: "请选择计算规则",
      SearchTags: "请搜索标签",
      EnterSearchKeywords: "请输入搜索关键字",
      CompletetheForm: "请填写完整",
      SelectTagValue: "请选择标签值",
      SelectMultipleAllowed: "请选择（可多选）",
      DynamicTime: "动态时间",
      SelectDate: "请选择日期",
      MyTags: "我的标签",
      AddFilteringModule: "增加筛选模块",
      PreviewandSave: "预览并保存",
      temporarySave: "临时保存",
      CompletetheConditions: "请补全条件！",
      tip1: "请删除“已禁用”标签相关条件！",
      TagID: "标签ID",
      ChineseTagName: "标签中文名",
      EnterChineseTagName: "请输入标签中文名",
      EnterTagID: "请输入标签ID",
      search: "查询",
      TagDisplay: "标签展示",
      TagList: "标签列表",
      Tag: "标签",
      Favorite: "收藏",
      IfBookmark: "是否收藏？",
      CancelBookmarking: "是否取消收藏？",
      Cancel: "取消",
      Confirm: "确定",
      AndCnd: "增加AND条件",
      OrCnd: "增加OR条件",
      InInterval: "在区间",
      EqualsTo: "等于",
      NotEqualTo: "不等于",
      GreaterThan: "大于",
      GreaterThanOrEqualTo: "大于等于",
      LessThan: "小于",
      LessThanOrEqualTo: "小于等于",
      Include: "包含",
      Excluding: "不包含",
      FilterSubSegment: "临时人群列表",
    },
    uploadGroup: {
      title1: "数据分析",
      title2: "上传人群",
      title3: "人数",
      title4: "人群id生成规则",
      title5: "自动生成",
      title6: "手动生成",
      title7: "人群ID",
      title8: "请输入人群id",
      title9: "人群名称",
      title10: "请输入人群名称",
      title11: "人群sql",
      title12: "请输入人群sql",
      title13: "请选择人群生成规则",
    },
    userGroupList: {
      audience: "人群",
      audienceList: "人群管理",
      groupName: "分群名称",
      pleaseEnterGroupName: "请输入分群名称",
      groupType: "分组类型",
      pleaseSelectGroupType: "请选择分组类型",
      regularAudience: "普通人群",
      uploadAudience: "上传人群",
      customAudience: "自定义人群",
      creator: "创建人",
      pleaseEnterCreatorName: "请输入创建人",
      search: "查询",
      clickOnThePopulationName: "点击人群名称",
      viewAudienceRules: "查看人群规则",
      createAudience: "创建人群",
      audienceID: "人群ID",
      audienceName: "人群名称",
      numberOfUsers: "用户数",
      creationTime: "创建时间",
      calculationType: "计算类型",
      lastCalculationTime: "最近计算时间",
      status: "状态",
      operation: "操作",
      disable: "禁用",
      enable: "启用",
      copy: "复制",
      edit: "编辑",
      analysis: "分析",
      delete: "删除",
      theAudienceIsNotDelete: "当前人群处于使用或待使用状态不能被修改！",
      theAudienceIsNotAllowDelete: "人群已绑定策略，不能被删除",
      deleteTheAudienceConfirm: "确定删除该人群?",
      confirm: "确定",
      cancel: "取消",
      cancelDeleteOpration: "取消删除操作！",
      thisAudience: "该人群",
      ToBeExecuted: "待执行",
      InProgress: "执行中",
      Success: "成功",
      Failed: "失败",
      UserDeleteAdministrators: "用户删除管理员可见",
      Delete: "删除",
      disableThisAudienceConfirm: "确定禁用该人群?",
      enableThisAudienceConfirm: "确定启用该人群?",
      
      disableThisUseCaseConfirm: "确定禁用该策略?",
      enableThisUseCaseConfirm: "确定启用该策略?",
      disableThisAudienceCancel: "取消禁用操作!",
      enableThisAudienceCancel: "取消启用操作!",
      addItemGroup: "新增临时人群",
    },
    userItemGroupList: {
      audienceList: "子人群列表",
      groupName: "子分群名称",
      pleaseEnterGroupName: "请输入分群名称",
      groupType: "分组类型",
      pleaseSelectGroupType: "请选择分组类型",

      creator: "创建人",
      pleaseEnterCreatorName: "请输入创建人",
      search: "查询",
      clickOnThePopulationName: "点击人群名称",

      audienceMainID: "主人群ID",
      audienceID: "子人群ID",
      audienceName: "子人群名称",
      numberOfUsers: "用户数",
      creationTime: "创建时间",
      calculationType: "计算类型",
      lastCalculationTime: "最近计算时间",
      status: "状态",
      operation: "操作",
      disable: "禁用",
      enable: "启用",
      copy: "复制",
      edit: "编辑",
      analysis: "分析",
      delete: "删除",
      theAudienceIsNotDelete: "当前人群处于使用或待使用状态不能被修改！",
      theAudienceIsNotAllowDelete: "人群已绑定策略，不能被删除",
      deleteTheAudienceConfirm: "确定删除该人群?",
      confirm: "确定",
      cancel: "取消",
      cancelDeleteOpration: "取消删除操作！",
      thisAudience: "该人群",
      ToBeExecuted: "待执行",
      InProgress: "执行中",
      Success: "成功",
      Failed: "失败",
      UserDeleteAdministrators: "用户删除管理员可见",
      Delete: "删除",
      addItemGroup: "新增临时人群",
    },
    userGroupDetail: {
      audienceRules: "人群规则",
      filterExploration: "筛选探索",
      goBack: "返回",
      totalNumberOfPeople: "总人数",
      people: "人",
    },
    userAnalysis: {
      all: "全部",
      audienceDashboard: "人群看板",
      membershipAttributes: "会员属性",
      consumptionBehaviorPreferenceAttr: "消费行为偏好属性",
      consumptionBehaviorDataAttr: "消费行为数据属性",
      selectAudience: "请选择人群",
      totalMembershipCount: "会员总人数",
      membershipClassification: "会员分类",
      regularMembers: "普通会员",
      OHMembers: "OH麦卡会员",
      breakfastCardMembers: "早餐卡会员",
      McCafeMembers: "麦咖啡会员",
      membershipStatus: "会员状态",
      registrationChannel: "注册渠道",
      numberOfPeople: "人数",
      Proportion: "active用户各渠道人数/比重",
      City: "最常消费市场&城市",
      PurchasePeriod: "购买时段偏好",
      Ingredients: "最常购买的产品-成分",
      Taste: "最常购买的产品-口味",
      CookingMethod: "最常购买的产品-烹饪方式",
      CityRanking: "城市排名",
      Cycle: "周期",
      TimePoint: "时间点",
      DaysSinceLastOrder: "最近一单距今天数",
      FreqStats: "消费频次统计",
      AvgDaysperPerson: "人均天数",
      AvgFreqperPerson: "人均次数",
      Times: "次",
      Days: "天",
    },
    pushStrategy: {
      precisionCommunication: "精准沟通",
      behaviorManagement: "行为管理",
      add: "添加",
      confirm: "确定",
      pleaseAddBehavior: "请添加行为",
      confirmDeletion: "确认删除",
      cancel: "取消",
      createBehavior: "创建行为",
      behaviorSelection: "行为选择",
      intelligentOrNot: "是否智能",
      intelligentMode: "智能模式",
      unintelligent: "非智能",
      yes: "是",
      no: "否",
      nextStep: "下一步",
      stuffCouponCoupon: "塞券",
      onlyProcess: "仅处理",
      reminderSettings: "提醒设置",
      pushTemplateSelection: "推送模板选择",
      smartCopywriting: "智能文案",
      customizedCopy: "自定义文案",
      copywritingPushRule: "文案推送规则",
      sequentialOrder: "顺序原则",
      randomPrinciple: "随机原则",
      eventPrinciple: "事件原则",
      smartPreferencePrinciple: "智能偏好原则",
      pushMessage: "推送文案",
      chooseText: "选择文案",
      dateEvent: "日期事件",
      actionEvents: "行为事件",
      workingDay: "工作日",
      weekend: "周  末 ",
      holiday: "节假日",
      reminderTime: "提醒时间",
      intelligentTime: "智能时间",
      fixedTime: "固定时间",
      pushTimeOnlyTwoHours:
        " 当天推送时间设置只能晚于当前时间2个小时。否则无法今天推送。",
      reminderStartAndEndDate: "提醒起止日期",
      crowdDataTime: "人群数据时间",
      saveAndAddAction: "保存并添加动作",
      pleaseSelectTime: "请选择时间",
      handleActionSettings: "处理行为设置",
      pleaseSelectChannel: "请选择渠道",
      time: "时间",
      stuffCouponSetting: "塞券设置",
      periodicDelivery: "投放周期",
      couponName: "优惠券名称",
      pleaseSelect: "请选择",
      save: "保存",
      pleaseSelectAction: "请选择行为选择",
      pleaseSelectIntelligentOrNot: "请选择是否智能",
      cannotBeEmpty: "不能为空",
      reminder: "提醒",
      smartReminder: "智能提醒",
      intelligentDataProcessing: "智能数据处理",
      intelligentStuffCoupon: "智能塞券",
      immediatePush: "立即推送",
    },

    userManagement: {
      title1: "系统设置",
      title2: "用户管理",
      title3: "用户列表",
      pageTitle: "用户管理",
      tableTitle: "用户ID",
      tableTitle1: "昵称",
      tableTitle2: "用户角色",
      tableTitle3: "登录邮箱",
      tableTitle4: "创建人",
      tableTitle5: "创建时间",
      tableTitle6: "修改人",
      tableTitle7: "修改时间",
      tableAction: "操作",
      addUserBttn: "新增用户",
      addUserTitle: "新增用户",
      addUserTitle1: "取消",
      addUserTitle2: "保存",
      addUserTitle3: "昵称",
      addUserTitle4: "请输入昵称",
      addUserTitle5: "密码",
      addUserTitle6: "请输入密码",
      addUserTitle7: "随机",
      addUserTitle8: "输入",
      addUserTitle9: "登录邮箱",
      addUserTitle10: "请输入登录邮箱",
      addUserTitle11: "用户角色",
      addUserTitle12: "请选择用户角色",
      addUserMsg1: "用户邮箱不能为空！",
      addUserMsg2: "邮箱不能为空！",
      addUserMsg3: "请选择用户角色！",
      addUserMsg4: "密码不能为空！",
      addUserMsg5: "请输入正确的邮箱",
      addUserMsg6: "邮箱校验中",
      searchMsg1: "请输入用户ID",
      searchMsg2: "请输入用户邮箱",
      searchTitle1: "用户邮箱",
      searchBtn1: "查 询",
      searchSucMsg: "查询成功！",
      searchFailMsg: "查询失败！",
      editUserTitle: "编辑用户",
      userMgtMsg1: "新增用户成功！",
      userMgtMsg2: "查询角色失败！",
      userMgtMsg3: "更新成功！",
      //popup
      popupTitle1: "确定启用这个用户吗?",
      popupTitle2: "启用后该用户将拥有对应权限?",
      popupTitle3: "启用",
      popupTitle4: "确定禁用这个用户吗?",
      popupTitle5: "禁用后将禁止登录",
      popupTitle6: "禁用",
      popupTitle7: "启用用户成功",
      popupTitle8: "禁用用户成功",

      emailExistsTitle: "邮箱已存在",
      emailExistsContent:'该邮箱已存在，是否将其加入到本订阅下？',
      bindRole: "绑定角色",
    },
    accountDashboard:{
      title1: "账号看板",
      title2: "info",
      title3: "已使用",
      title4: "剩余用量",
      title5: "使用占比",
    },
    logData: {
      title1: "设置",
      title2: "登录日志",
      tableTitle1: "登录概况",
      tableTitle2: "登录详情",
      tableTitle3: "登录人",
      tableTitle4: "登录时间",
    },
    systemManagement: {
      title1: "系统设置",
      title2: "系统管理",
      pageTitle: "系统管理",
      tabTitle1: "角色管理",
      tabTitle2: "按钮管理",
      tabTitle3: "资源菜单",
      searchBtn: "查 询",
      //角色管理table
      roleId:'角色ID',
      roleMgtBtn: "添加角色",
      roleMgtTitle: "角色列表",
      roleMgtTitle1: "角色名称",
      roleMgtTitle2: "是否为管理员",
      roleMgtTitle3: "角色描述",
      roleMgtTitle4: "创建时间",
      roleMgtTitle5: "操作",
      roleMgtTitle6: "创建人",
      roleSearchMsg: "请输入角色名称",
      roleAddTitle: "添加角色",
      roleAddTitle1: "取消",
      roleAddTitle2: "保存",
      roleAddTitle3: "权限",
      roleAddTitle4: "管理员",
      roleAddTitle5: "是",
      roleAddTitle6: "否",
      roleAddTitle7: "请输入描述信息",
      roleAddMsg1: "角色名称不能为空",
      roleEditTitle: "编辑角色",
      //按钮管理table
      btnMgtTitle: "按钮管理",
      btnDetailTitle: "操作详情",
      btnMgtTitle1: "分配按钮权限",
      btnMgtTitle2: "拥有的菜单按钮",
      btnMgtTitle3: "备注",
      btnMgtTitle4: "请选择按钮权限",
      btnMgtTitle5: "分配",
      //资源管理table
      resSearchTitle: "菜单名称",
      resSearchMsg: "请输入菜单名称",
      resMgtTitle: "菜单列表",
      resMgtTitle1: "图标",
      resMgtTitle2: "地址",
      resMgtTitle3: "描述",
      resMgtTitle4: "修改时间",
      resMgtTitle5: "操作",
      resMgtTitle6: "修改人",
      menuMgtTitle1: "编辑资源菜单",
      menuMgtTitle2: "菜单图标(二级菜单不显示)",
      menuMgtTitle3: "请输入描述信息",
      // message
      sysMgtMsg1: "操作成功！",
      sysMgtMsg2: "删除该角色成功！",
      sysMgtMsg3: "提交审核成功！",
      sysMgtMsg4: "修改成功！",
      sysMgtMsg5: "修改失败！",
      ConfirmDeleteRole: "确认删除该角色？",
      saveWhitelist: "是否确认保存白名单?",
      saveBlacklist: "是否确认保存黑名单?",
      canceled: "已取消！",
    },
    txtManagement: {
      title1: "文案管理",
      title2: "文案模板列表",
      tableTitle1: "文案ID",
      tableTitle2: "文案名称",
      tableTitle3: "渠道",
      tableTitle4: "内容",
      tableTitle5: "创建人",
      tableTitle6: "创建时间",
      tableTitle8: "状态",
      tableTitle7: "操作",
      txtSearchDefault: "文案ID/文案名称/文案渠道",
      labelBtn: "文案标签",
      addBtn: "新建模板",
      editBtn: "编辑模板",
      lableTitle: "文案标签管理",
      lableSideTitle: "文案标签展示",
      lableTitle1: "标签详情",
      lableTitle2: "创建标签",
      lableTitle3: "编辑",
      lableTitle4: "删除",
      lableTitle5: "确认删除？",
      lableEditTitle: "编辑标签",
      lableEditTitle1: "确认并保存",
      lableEditTitle2: "标签标识",
      lableEditTitle3: "标签名称",
      lableEditTitle4: "请输入标签名称",
      lableEditTitle5: "父级",
      lableEditTitle6: "请选择父级",
      lableEditTitle7: "是否启用",
      lableEditTitle8: "启用",
      lableEditTitle9: "不启用",
      lableAddTitle: "新增标签",
      lableMsg1: "请输入标签标识",
      lableMsg2: "请填写标签名称",
      lableMsg3: "请选择是否启用",
      AddFormTitle1: "新建",
      AddFormTitle2: "智能优惠券占位符：",
      AddFormTitle3: "文案渠道：",
      AddFormTitle4: "推送渠道",
      AddFormTitle5: "选择渠道",
      AddFormTitle6: "文案名称",
      AddFormTitle7: "标签",
      AddFormTitle8: "请选择拥有的标签",
      AddFormTitle9: "文案标题",
      AddFormTitle10: "已输入",
      AddFormTitle11: "字符",
      AddFormTitle12: "跳转链接",
      AddFormTitle13: "推送目标名称",
      AddFormTitle14: "推送ID",
      AddFormTitle15: "保存并生效",
      AddFormTitle16: "内容",
      AddFormTitle17: "编辑文案",
      AddFormTitle18: "确定",
      txtMgtMsg1: "确定删除这条文案吗?",
      txtMgtMsg2: "此操作将永久删除该文案",
      txtMgtMsg3: "删除成功！",
      txtMgtMsg4: "删除操作取消！",
      txtMgtMsg5: "创建成功",
      messageAddedSuc: "新增文案成功！",
      reasonTitle: "失败原因",
      createPush: "创建推送",
      sms: "短信",
      email: "邮件",
      userPlace:'用户占位符',
      couponPlace:'优惠券占位符',
      content:'文案内容',
    },
    strategyManagement: {
      title1: "精准沟通",
      title2: "策略管理",
      title3: "策略管理列表页",
      title4: "全局控制",
      globalTitle1: "全局次数限制",
      globalTitle2: "控制组锁定时间",
      globalTitle3: "黑白名单管理",
      globalTitle4: "过滤管理",
      globalTitle5: "策略分类管理",
      globalTitle6: "自定义去重管理",
      globalTitle7: "过滤时间控制",
      globalTitle8: "任务提醒管理",
      tabTitle1: "策略",
      tabTitle2: "指标参数",
      buttonTitle1: "确认调整",
      buttonTitle2: "调整优先级",
      buttonTitle3: "优先级排序",
      buttonTitle4: "查询",
      strategyLabel1: "策略ID",
      strategyLabel2: "策略名称",
      strategyLabel3: "投放时间",
      strategyPlaceholder1: "请输入策略ID",
      strategyPlaceholder2: "请输入策略名称",
      strategyTableTitle1: "优先级排序",
      strategyTableTitle2: "周期性",
      strategyTableTitle3: "开始时间",
      strategyTableTitle4: "结束时间",
      strategyTableTitle5: "是否排序",
      strategyTableTitle6: "策略次数控制",
      strategyTableTitle7: "控制组比例",
      strategyTableTitle8: "是否生效",
      strategyTableTitle9: "推送状态",
      strategyTableTitle10: "操作",
      operateTip1: "策略详情",
      operateTip2: "编辑策略",
      operateTip3: "删除策略",
      operateTip4: "确认删除策略?",
      globalTitle: "全局次数限制",
      globalText: "保存设置",
      globalText1: "每",
      globalText2: "推送一次",
      globalText3: "取消",
      controlText1: "控制组锁定时间",
      BWlistTitle: "黑白名单管理",
      BWlistFooter1: "黑名单管理:",
      BWlistFooter2: "白名单管理",
      BWlistFooter3: "不启用",
      BWlistFooter4: "启用",
      BWlistFooter5: "过滤",
      BWMTitle1: "白名单",
      BWMTitle2: "黑名单",
      BWMPlaceholder: "输入mid/分组查找",
      BWMBtn1: "新增名单",
      BWMBtn2: "新增分组",
      BWMTableCol1: "序号",
      BWMTableCol2: "类型",
      BWMTableCol3: "适用策略",
      BWMTableCol4: "生效日期",
      BWMTableCol5: "失效日期",
      BWMTableCol6: "分组",
      BWMAddTitle: "新增名单",
      BWMAddText: "类型",
      BWMAddText2: "日期",
      BWMAddRules1: "请输入mid",
      BWMAddRules2: "请选择分组",
      BWMAddRules3: "请选择策略",
      BWMAddRules4: "请选择日期范围",
      BWMAddRules5: "请填写分组名称",
      BWMAddRules6: "请填写分组描述",
      BWMAddGroup1: "分组名称",
      BWMAddGroup2: "分组描述",
      BWMAddGroup3: "新增分组",
      BWMTplacholer1: "请输入mid（批量增加请用英文逗号间隔）",
      BWMTplacholer2: "请选择All/多个策略",
      BWMEditTitle: "编辑名单",
      BWMEditOk: "确认并保存",
      BWMEditText1: "编辑",
      BWMEditText2: "删除",
      BWMEditText3: "确认删除?",
      BWMEditText4: "确认",
      filterTitle: "过滤管理",
      filterBtn1: "规则库",
      filterBtn2: "新建规则",
      filterBtn3: "创建分组",
      filterCol1: "名称",
      filterCol2: "内容",
      filterCol3: "描述",
      filterCol4: "更新时间",
      filterCol5: "修改人员",
      filterAddTitle1: "过滤分组(创建)",
      filterAddTitle2: "过滤分组(修改)",
      filterAddText1: "选择规则",
      filterAddRules1: "请输入分组名称",
      filterAddRules2: "请选择规则",
      filterAddRules3: "请输入描述",
      filterRuleTitle1: "创建规则",
      filterRuleTitle2: "修改规则",
      filterRuleCol1: "值",
      filterRuleCol2: "选择来源",
      filterResource1: "历史控制天数",
      filterResource2: "全局控制天数",
      filterResource3: "人群列表",
      filterRuleCol3: "控制范围",
      filterRuleCol4: "选择人群",
      filterRuleText2: "天",
      filterRule1: "请输入规则名称!",
      filterRule2: "请输入规则 value!",
      filterRule3: "请选择来源!",
      filterRule4: "请输入控制范围!",
      filterRule5: "请选择人群!",
      deletePop: "确认要删除吗?",
      filterRule8: "规则名称",
      filterRule6: "说明",
      classificationTitle: "策略分类管理",
      classificationTitle1: "分类展示",
      classificationTitle2: "分类详情",
      classificationBtn1: "新增分类",
      classfiDeleteTip: "删除会导致选择该分类的策略分类显示异常",
      classfiDeleteok: "是否确认删除",
      classfiTableCol1: "类型标识",
      classfiTableCol2: "类型名称",
      classfiTableCol3: "父级",
      classfiAddTitle: "新增分类",
      classfiEditTitle: "编辑分类",
      classTablecol1: "归属父级",
      classTablecol2: "请选择父ID",
      classTablecol3: "分类ID",
      classTablecol4: "分类名称",
      classRules1: "ID不能为空！",
      classRules2: "分类名称不能为空！",
      deduplicationTitle: "自定义去重管理",
      timeControlTitle: "过滤时间控制",
      timeControlOk: "确认过滤时间",
      timeControlCancle: "取消设置",
      timeControlTable: "开启过滤时间：",
      Daily: "每日",
      timeControlText: "填写时间默认开启当前时间，空白时间为不开启定时过滤",
      WeChatTitle: "微信预警配置",
      dupCreatenewgroup: "新建分组",
      dupSearchbyname: "输入分组名称查找",
      creator: "创建人",
      nameClassification: "策略名称/分类",
      nameClassificationSearch: "输入策略名称/分类查找",
      Priority: "优先级",
      StrategyClassification: "策略分类",
      Group: "分组",
      Save: "保存",
      EditGroups: "编辑分组",
      inputNameSearch: "输入群名称查找",
      Newrobot: "新建机器人",
      Robotnumber: "机器人编号",
      EnterRobotNumber: "请输入机器人编号",
      WeChatname: "微信名称",
      enterWeChatname: "请输入微信名称",
      Whetherenable: "是否启用",
      selectwhetherenable: "请选择是否启用",
      Editrobot: "编辑机器人",
      Groupname: "群名称",
      status: "状态",
      Newtemplate: "新增模板",
      Mode: "模式",
      selIndicator: "选用指标",
      Indicatorselection: "指标选择",
      Addfilteringmodule: "增加筛选模块",
      addOrconditions: "增加OR条件",
      addAndconditions: "增加AND条件",
      Selectlabel: "请选择标签",
      Selectcalculationrule: "请选择计算规则",
      fillcompletely: "请填写完整",
      fillvalue: "请填写数值",
      templateinfo: "模板信息",
      Savestrategy: "保存策略",
      Next: "下一步",
      Close: "关闭",
      StartActivationStatus: "策略是否开启",
      Yes: "是",
      No: "否",
      Enterornotruleengine: "是否进入rule engine",
      EnterFilteringProcess: "可选择策略是否进入过滤处理",
      Selectfilterrule: "选择过滤规则",
      CustomizedDeduplication: "自定义去重",
      CtrlGroup: "预留控制组",
      PeriodicDelivery: "投放周期",
      Singletime: "单次",
      WorkDay: "工作日",
      Weekend: "周末",
      Cycle: "周期",
      PushSameDay: "是否当天推送",
      Validityperiod: "策略有效期",
      startDate: "开始日期（包含）",
      endDate: "结束日期（包含）",
      DefaultGregdate: "默认阳历日期",
      Frequency: "频率",
      Perday: "按天",
      Everyweek: "按周",
      Permonth: "按月",
      Everyworkday: "每个工作日",
      Everyweekend: "每个周末",
      days: "天",
      RepeatInterval: "重复间隔(C)",
      weekslater: "周后的",
      monthonthe: "个月的第",
      thday: "天",
      TargetAud: "目标人群",
      PriorityLevelTargetAud: "人群优先级",
      TrafficDistributionEntry: "是否进入分流",
      IntelligentTrafficDistribution: "智能分流",
      Tips: "提示",
      Previous: "上一步",
      FillinName: "请填写名称",
      FillinDescription: "请填写描述",
      ModeSelection: "模式选择",
      SelectMode: "请选择模式",
      DataControl: "数据控制",
      SelectApplicableStrategy: "请选择适用策略",
      SelectDataControl: "请选择数据控制",
      ConfirmPrioritySorting: "确定优先级排序吗?",
      DailyPush: "日推送一次",
      AlreadyPushed: "已推送",
      NotPushed: "未推送",
      CurrentStatusStrategy: "策略当前指标情况",
      FrequencyLimitationCannotBeEmpty: "全局次数限制不能为空",
      FilterRuleCreatedSuccessfully: "创建过滤规则成功！",
      SavedFilterRules: "保存过滤规则成功！",
      FailedToCreateFilterRule: "创建过滤规则失败！",
      SelectImportanceLevel: "请选择重要性！",
      SelectCategory: "请选择覆盖品类！",

      StrategyDeliveryInfo: "策略投放信息",
      StrategyIDRange: "策略ID范围",
      SingleDelivery: "单次投放",
      IndicatorParameterStatus: "指标参数情况",
      SelectTargetAudience: "请选择目标人群！",
      ChooseAudienceFiltering: "请选择人群筛选！",
      StrategyValidityPeriodEmpty: "策略有效期不能为空！",
      customizedOnlyOne:
        "提示：自定义过滤规则 （ 间隔天数过滤规则 ）只能选择一个！",
      adjustThePriority: "是否确认调整优先级？",
      DateCannotBeEmpty: "日期不能为空！",
      CategoryDeletedSuccessfully: "删除分类成功",
      CategoryDeletedException: "删除分类异常",
      CategoryAddSuccessfully: "新增分类成功",
      CategoryAddException: "新增分类异常",
      UploadAvatarSuccessfully: "头像上传成功",

      CategoryEditSuccessfully: "修改分类成功",
      CategoryEditException: "修改分类异常",
      AddFilteringModule: "请添加筛选模块！",
      timeZoneWarning:'请选择一个将来的时间'
    },
    couponManagement: {
      title1: "优惠券管理",
      title2: "优惠券列表",
      tableTitle1: "优惠券序号",
      tableTitle2: "名称",
      tableTitle3: "优惠券名称",
      tableTitle4: "优惠券ID",
      tableTitle5: "智能优惠券名称",
      tableTitle6: "创建时间",
      editFormTitle: "修改优惠券",
      editFormTitle1: "标签",
      couponMgtMsg1: "未做更改",
      couponMgtMsg2: "参数不能为空",
      couponMgtMsg3: "是否删除此优惠券?",
      couponMgtMsg5: "此优惠券被行为选中。",
      couponMgtMsg4: "取消删除操作！",
      title3: "确定",
      title4: "取消",
      searchDefault: "名称/优惠券ID/限制地区",
      couponMgtBtn1: "优惠券标签",
      couponMgtBtn2: "新建优惠券",
      couponTagTitle: "优惠券标签管理",
      couponTagTitle1: "标签详情",
      couponTagTitle2: "创建标签",
      couponTagTitle3: "编辑",
      couponTagTitle4: "删除",
      couponTagTitle5: "确认删除?",
      couponTagSideTitle: "优惠券标签展示",
    },
    DataSetTagManagement: {
      title1: "数据设置",
      title2: "标签管理",
      title3: "提交记录",
      tagTabTitle1: "标签ID",
      tagTabTitle2: "标签",
      tagTabTitle3: "创建日期",
      tagTabTitle4: "标签更新日期",
      tagTabTitle5: "标签触发率",
      tagTabTitle6: "禁用/启用",
      recdTabTitle1: "提交用户",
      recdTabTitle2: "提交时间",
      recdTabTitle3: "功能",
      recdTabTitle4: "操作详情",
      recdTabTitle5: "操作备注",
      //popup
      popupTitle1: "确定启用这个标签吗?",
      popupTitle2: "启用后其他用户将拥有该标签的概览权限?",
      popupTitle3: "启用",
      popupTitle4: "确定禁用这个标签吗?",
      popupTitle5: "禁用后其他用户将失去该标签的概览权限",
      popupTitle6: "禁用",
    },
    strategyStore: {
      contactType: "触达类型",
      SelectCrowdStatus: "选择人群状态",
      StaticAudience: "静态人群",
      DynamicCustGroup: "动态人群",
      preciseComm: "精准沟通",
      strategyLibrary: "策略库",
      regularStrategy: "常规策略",
      strategyDetails: "策略详情",
      editStrategy: "策略修改",
      businessPurpose: "业务目的",
      crowdDefinition: "人群定义",
      priority: "优先级",
      commCycle: "沟通周期",
      controlGroupProportion: "控制组比例",
      lockinPeriod: "锁定期",
      strategy: "策略",
      strategyCategoryManagement: "策略分类管理",
      saveStrategy: "保存策略",
      strategyID: "策略ID",
      strategyName: "策略名称",
      strategyClassification: "策略分类",
      periodicdelivery: "投放周期",
      timezone: "时区",
      repeat: "重复",
      on:'在',
      singleTime: "单次",
      workDay: "工作日",
      weekend: "周末",
      cycle: "周期",
      selectFrequency: "选择频率",
      validityPeriod: "策略有效期",
      enterOrNot: "是否进入",
      filteringRuleSelect: "选择过滤规则",
      defaultFilterRule: "默认过滤规则",
      viewChangeFilters: "请至过滤规则管理查看或更改",
      customizedFilters: "自定义过滤规则",
      controlCreateRule: "如需新建过滤规则，请至全局控制-创建过滤规则",
      selectCustomizedFilteringRules: "选择自定义过滤规则",
      selectChoose: "请选择",
      defaultGregDate: "默认阳历日期",
      frequency: "频率",
      perDay: "按天",
      everyWeek: "按周",
      perMonth: "按月",
      every: "每",
      everyWeekend: "每个周末",
      thDay: "天",
      days: "天",
      repeatInterval: "重复间隔",
      weeksLater: "周后的",
      WeekByWeek: "每周",
      monthOnThe: "个月的第",
      targetAud: "目标人群",
      priorityLevelTargetAud: "人群优先级",
      remarkTopPriority: "备注：1为最高优先等级",
      reserveCtrlGroup: "预留控制组",
      numberProportion: "人数占比",
      numberControl: "人数控制",
      fixedQuantityAfterDedup: "去重后固定数量",
      selectionResultsBased: "基于实际圈选结果",
      minNumberAfterDeduplication: "去重后最少数量",
      maxQtyAfterDedup: "去重后最大数量",
      specialOccasion: "特殊情况",
      strategyInformation: "策略信息",
      strategyIDGenerate: "策略ID生成",
      strategyImplement: "策略执行",
      stratExecName: "策略执行名称",
      enterExecName: "请输入策略执行名称",
      strategyImplementID: "策略执行id",
      enterStrategyImplementID: "请输入策略执行id",
      pleaseEnterID: "请输入ID",
      pleaseEnterName: "请输入名称",
      pleaseEnterContent: "请输入文案",
      monday: "星期一",
      tuesday: "星期二",
      wednesday: "星期三",
      thursday: "星期四",
      friday: "星期五",
      saturday: "星期六",
      sunday: "星期日",
      dedupFilter: "去重过滤",
      histControlFilters: "历史控制组过滤",
      globalIntervalFilter: "全局间隔天数过滤",
      globalControlFilters: "全局控制组过滤",
      lifecycleBasedStrategy: "基于生命周期的策略",
      TimeScenarioStrat: "基于场景时间的策略",
      regionBasedStrat: "基于地区的策略",
      coopWithMarketing: "配合营销的策略",
      marketingBasedStrat: "基于营销的策略",
      channelBasedStrat: "基于渠道的策略",
      behaviorBasedStrat: "基于行为的策略",
      eventBasedStrategy: "基于事件的策略",
      activateOrderCust: "首单激活",
      stimuNextOrder: "下一单刺激",
      orderUplift: "频率下降用户提频",
      recallCustomerLoss: "流失召回",
      breakfastScene: "早餐场景",
      nightSnakeScene: "夜宵场景",
      singlePersonStimul: "单人场景刺激",
      multiPersonStimul: "多人场景刺激",
      familyScene: "家庭场景",
      lowTierCities: "低线城市",
      supportWeakStores: "新店铺扶持",
      remindMemberActivityBrowsing: "会员活动浏览后提醒",
      remindAddToCart: "加购未下单提醒",
      remindNewProdClicks: "新品点击用户提醒",
      remindNewProd: "新品用户提醒",
      supportHighCompStores: "高竞争店铺扶持",
      publicDomainToOwnPlatform: "公域转化自有平台",
      takeawayToPlatformConv: "外卖转自有平台",
      takeawayToDineConv: "外卖转堂食",
      dineConvToTakeaway: "堂食转外卖",
      coordinatingWithMemberCampaign: "配合会员活动",
      rainStimul: "雨天刺激",
      hyperthermiaStimul: "高温刺激",
      cityRebound: "城市反弹",
      supportForNewStores: "新店扶持",
      cooperateWithProdPromo: "配合产品促销",
      coopWithNewProd: "配合新品促销",
      epidemicRecovery: "疫情恢复",
      remindNextOrder: "结合用户的生命周期，对其进行下一单提醒，提升消费频率",
      reminderByTime: "针对特性时间和场景的提醒，提升该场景的用户参与",
      targetCommunSupport: "对于重点地区和店铺，进行定向的沟通扶持",
      communWithMarket: "配合营销活动进行沟通，最大化营销活动的效果",
      cultivateUserHabit:
        "进行渠道间的转化，培养用户多渠道消费习惯，培养用户私域消费习惯",
      afterUserOnline: "在用户有在线互动行为后，进行二次沟通，提升转化率",
      predictAndComunicate: "对于特定时间进行预测和沟通，如疫情",
      selectFilterRule: "请选择过滤规则",
      pleaseSelectCustomizedFilteringRules: "请选择自定义过滤规则",
      pleaseEnterStrategyID: "请输入策略ID",
      enterStrategyName: "请输入策略名称",
      validityPeriodOfDelivery: "请选择投放有效期",
      selectStartDate:'请选择开始日期',
      selectEndDate:'请选择结束日期',
      selectedTimezone: "请选择时区",
      selectRepeat: "请选择重复",
      selectOne: "请选择至少一个",
      selectStratCategory: "请选择策略分类",
      pleaseSelectRuleEngine: "请选择rule engine",
      periodicDeliverySelect: "请选择投放周期",
      incFrequencyActivity: "提频xx活动",
      incFrequency: "提频",
      deliveryAud: "投放人群",
      saveEvents: "保存活动",
      recallCustomerLossActivity: "流失召回xx活动",
      recallCustomerLossBBQBIC: "流失召回BBQBIC",
      lostRecallMidAut: "流失召回中秋多城市下单",
      recallCustomerLossBA: "流失召回BA",
      recallLongLossActivity: "长流失召回xx活动",
      recallLongTermLoss: "长流失召回",
      lostRecall5th6thOrder: "五单六单流失",
      lostRecall4th5thOrder: "四单五单流失",
      lostRecall3th4thOrder: "三单四单流失",
      lostRecall2th3thOrder: "二单三单流失",
      lostRecall1th2thOrder: "首单二单流失",
      preventLostBrows: "流失预防浏览",
      preventLostByAddToCart: "流失预防加购",
      preventCustLoss: "流失预防",
      recallLongTermLossPay: "长流失召回支付行为",
      recallLostBrowsAddToCart: "流失召回浏览&加购",
      closeDurToEpidemicCity: "疫情关店xx城市…",
      closeDurToEpidemic: "疫情关店",
      recallCustomerLossCity: "流失召回xx城市…",
      memberDayHappyMeal: "会员日happymeal",
      memberDayLostRecall: "会员日流失召回",
      memberDay: "会员日",
      lostRecallDessert: "流失召回甜品",
      recallCustomerLossRGM: "流失召回RGM",
      recallCustomerLossSMS: "流失召回SMS",
      breakfastCard: "早餐卡",
      breakfastReminder: "早餐提醒",
      activateNewMembers: "新会员激活",
      activate: "激活",
      applet: "小程序",
      onlyHandle: "仅处理",
      preChurnTest: "pre-churn测试",
      freqInc1Order: "新用户提频1单",
      freqInc2Orders: "新用户提频2单",
      freqInc3Orders: "新用户提频3单",
      freqInc4Orders: "新用户提频4单",
      freqInc5Orders: "新用户提频5单",
      freqInc: "新用户提频",
      activateFreq1Order: "激活用户提频1单",
      activateFreq: "激活用户提频",
      test: "测试",
      periodicDeliveryFreq: "请选择投放周期的 '频率'！",
      selectDailyDeliv: "请选择按天投放的类型！",
      selectDelivDays: "请选择按天投放的天数 ！",
      weeklyIntervalSelect: "请选择按周投放的间隔日期！",
      monthDaysForDelivery: "请选择按月投放的月份和天数！",
      notbeEarlier: "结束日期不能早于开始日期！",
    },

    resultDashboard: {
      title1: "精准沟通",
      title2: "效果看板",
      title3: "运营概览",
      title4: "分析比较",
      DataTabTitle1: "请选择",
      DataTabTitle2: "发券人数",
      AnalyTabTitle1: "数据指标",
      AnalyTabTitle2: "请选择数据指标",
      AnalyTabTitle3: "策略1",
      AnalyTabTitle4: "请选择添加策略",
      AnalyTabTitle5: "时间区间",
      AnalyTabTitle6: "开始分析",
      AnalyTabTitle7: "请选择策略1",
      AnalyTabTitle8: "请选择时间区间",
      strat: "策略",
      SummaryStrategies: "策略汇总",
      TimeType: "时间类型",
      TimeRange: "时间范围",
      RegionRange: "地区范围",
      PleaseSelectRegion: "请选择地区范围",
      ChannelScope: "渠道范围",
      SelectChannel: "请选择渠道",
      ViewResults: "查看结果",
      TotalSalesRevenue: "总销售额",
      PleaseSelectCustomerType: "请选择顾客类型",
      TotalNumberMembers: "总会员人数",
      NumberOrders: "订单数量",
      NumberActiveMembers: "活跃会员人数",
      UserRetentionRate: "用户留存率",
      YearOnYearGrowthRate: "同比涨幅",
      likelyToChurn: "即将流失",
      NumberOfMembers: "会员人数",
      MonthOnMonthGrowthRate: "环比涨幅",
      NumberNewMembers: "新增会员人数",
      NumberHActiveMembers: "高活跃会员人数",
      NumberMActiveMembers: "中活跃会员人数",
      NumberLActiveMembers: "低活跃会员人数",
      QueryException: "查询异常!",
      PleaseSelectCondition: "请选择至少一个条件！",
      StrategyType: "策略类型",
      PleaseSelectStrategyType: "请选择策略类型",
      CouponType: "券类型",
      PleaseSelectCouponType: "请选择券类型",
      TotalSales: "总销售",
      NumberRecipientsReached: "触达人数",
      StrategyMetrics: "策略指标",
      ViewStrategyDetails: "查看策略详情",
      StrategyMetricDetails: "策略指标详情",
      StrategySearch: "策略搜索",
      PleaseEnterContent: "请输入内容",
      StrategyName: "策略名",
      SalesRevenue: "销售额",
      DiscountTheCoupon: "券的折扣力度",
      CouponRedemptionRate: "券核销率",
      OrderWithinPeriod: "有效期内下单率",
      PercentageIncreaseOrderRate: "下单率提升百分比",
      IncrementalSalesRevenue: "增量销售额",
      PercentageIncrementalSalesRevenue: "增量销售额占比",
      IncreaseSpendingPerson: "人均花费提升",
    },
    strategyPushMgt: {
      DelivStrat: "投放策略",
      delivered: "Delivered",

      DeliveryStrategyList: "投放策略列表页",
      ExclDeleted: "（不包括已删除）",
      ToBeStarted: "待启动",
      Expired: "已过期",
      Stopped: "已停止",
      AlreadyDeleted: "已刪除",
      strategyNameAudience: "策略ID/策略名称/人群ID",
      AddDelivery: "新增投放",
      StartEndDate: "起止日期",
      BehaviorCount: "行为数量",
      DelivCycle: "推送周期",
      InProgressCount: "进行中人数",
      CompletedPeopleCount: "完成人数",
      Operation: "操作",
      Details: "详情",
      DeliveryType: "投放类型",
      couponsCopywritingID: "券/文案ID",
      DelivTitle: "推送标题",
      PushTime: "推送时间",
      PushDate: "推送日期",
      DuplicateStrategy: "重复策略",
      Restore: "恢复",
      ThoroughDeletion: "彻底删除",
      IntelligentOptions: "智能选项",
      SmartCoupons: "智能优惠券",
      CustomizedCoupon: "自定义优惠券",
      SelectOptionPlese: "请选择方式",
      product: "产品",
      EnableDisableStrategyExecution: "可直接关闭策略运行或开启策略运行",
      setCrowdhistoricalControl:
        "按照百分比数量控制最后结果数据，进入历史控制的人数",
      saveToDefaultControlGroup: "是否保存到默认控制组",
      productQuantity3510:
        "非必选项，可以选择多个来源获取产品数据。重要性低、中、高分表代表产品取值数量3、5、10。",
      tips1:
        "必选项，只能选择一个目标作为券的分数计算。利润提升 ，调高券收益和券成本占比，降低惩罚项和券偏好占比(1,4,2,3)。客单数提升，调高券偏好，降低惩罚项占比，券成本占比，券收益占比(1,1,3,5)。销售额提升，调高券收益占比，降低惩罚项和券偏好占比，券成本占比(1,2,3,4)",
      tips2: "非必选项，排除重复发送次数的优惠券。",
      DaysAfterDelimitingTheCrowd: "圈人后天数",
      InProgress: "运行中",
      AvoidCouponsPushed: "避免已推送过的优惠券",
      stopSend: "次之后就不继续推送该优惠券",
      OptionalMsg1:
        "非必选项，选择优惠券设置该策略下推送优惠券的人数限制。可选择多张优惠券进行人数限制。",
      OptionalMsg2:
        "非必选项，当存在没有匹配到优惠券或者被优惠券数量控制所限制用户，将会给塞保底券。如果选择多张券，则使用选中的多张保底券在进行计算得出最匹配用户的券。",
      OptionalMsg3:
        "非必选项，选择相应的产品，调整该产品与用户的匹配度。可选择多个产品进行调整。",
      msg1: "不选择保底券，超出数量控制或者没有匹配到券的人员将会被过滤删除!",
      msg2: "可选择不与某一部分策略进行去重过滤",
      msg3: "输入的数值为不进入智能算法的数据。例：输入30% ，剩下的70%将会进入算法计算",
      Importance: "重要性",
      CoveredCategories: "覆盖品类",
      IncreaseSalesRevenue: "销售额提升",
      IncreaseOrderVolume: "客单数提升",
      IncreaseProfitability: "利润提升",
      PrimaryTargets: "主要目标",
      OtherTargets: "其他目标",
      SelectPrimaryTargets: "请选择主要目标！",
      EnterOtherTargets: "请填写其他目标 次数！",
      ProductPage: "产品页",
      BatchImportting: "批量导入中......",
      ProductAdjustment: "产品调整",
      ProductSelection: "产品选择",
      CouponQuantityControl: "优惠券数量控制",
      CouponSelection: "优惠券选择",
      BatchImport: "批量导入",
      aaa: "张",
      MinimumDiscountCoupon: "保底优惠券",
      DownloadTemplate: "下载模板",
      ProductID: "产品ID",
      ProductName: "产品名称",
      AdjustContent: "调整内容",
      ApplicationScope: "适用范围",
      CouponName: "优惠券名称",
      QuantityControl: "数量控制",
      CouponNumber: "优惠券序号",
      CouponID: "优惠券ID",
      searchNameOrID: "请搜索产品名/产品ID",
      EditContent: "修改内容",
      FixedPosition: "固定位置",
      Promote: "提升",
      Lower: "降低",
      Exclude: "排除",
      UsageRange: "使用范围",
      name1: "第一名",
      name2: "第二名",
      name3: "第三名",
      name4: "第四名",
      name5: "第五名",
      name6: "第六名",
      name7: "第七名",
      name8: "第八名",
      name9: "第九名",
      name10: "第十名",
      nameNum1: "一名",
      nameNum2: "二名",
      nameNum3: "三名",
      nameNum4: "四名",
      nameNum5: "五名",
      SelectModifiedContent: "请选择修改内容！",
      SelectFixedPosition: "请选择固定位置！",
      EnterPromotionInfo: "请填写提升！",
      FillDecreaseValue: "请填写降低！",
      SelectUsageRange: "请选择使用范围！",
      QueryCoupons: "查询优惠券",
      couponNameOrID: "请搜索优惠券名/优惠券ID",
      Tips: "提示",
      FillFrequencyControl: "请填写策略次数控制",
      EnterStrategyID: "请输入策略ID",
      selectRuleEngine: "请选择rule engine",
      AlreadyCreated: "已创建",
      NotCreated: "未创建",
      EditCouponInsertion: "编辑塞券",
      SaveCouponInsertion: "保存塞券",
      IntelligentTime: "智能时间",
      FixedTime: "固定时间",
      CouponStartEndTime: "塞券起止时间",
      CrowdDataTime: "人群数据时间",
      EditReminder: "编辑提醒",
      ViewReminder: "查看提醒",
      SaveReminder: "保存提醒",
      SelectReminderChannel: "选择提醒渠道",
      CopyMessageRule: "文案推送规则",
      PushCopyMessage: "推送文案",
      ChooseText: "选择文案",
      AlreadyFollowedOffAcc: "已关注公众号",
      NotFollowingOfficialAccount: "未关注公众号",
      AlreadyDownloadedApp: "已下载APP",
      NotDownloadedApp: "未下载APP",
      CouponSettings: "优惠券设置",
      SaveAndNextStep: "保存并下一步",
      SaveAddAction: "保存并添加动作",
      RestoreStrat: "恢复策略",
      IncludeBehavior: "包括行为",
      ExcludeBehaviors: "不包括行为",
      createStrategy: "创建策略",
      currentDay: "当日（T+0）",
      nextDay: "次日（T+1）",
    },
    StrategyGroup: {
      title1: "系统设置",
      title2: "任务管理",
      title3: "应用",
      pushTabTitle1: "今日",
      pushTabTitle2: "推送任务",
      pushTabTitle3: "下载推送结果",
      pushTabTitle4: "推送日期",
      pushTabTitle38: "推送版本",
      pushTabTitle5: "任务状态",
      pushTabTitle6: "标签同步",
      pushTabTitle39: "算法同步映射",

      pushTabTitle7: "数据准备",
      pushTabTitle8: "人群过滤",
      pushTabTitle9: "策略结果生成",
      pushTabTitle10: "人群结果生成",
      pushTabTitle11: "结果数据上传",
      pushTabTitle12: "上传数据校验",
      pushTabTitle13: "推送数据",
      pushTabTitle14: "推送成功",
      pushTabTitle15: "推送结果校验",
      pushTabTitle16: "人工推送",
      pushTabTitle17: "定时推送",
      pushTabTitle18: "未进行",
      pushTabTitle19: "进行中",
      pushTabTitle20: "已完成",
      pushTabTitle21: "已失败",
      pushTabTitle22: "黑名单同步",
      pushTabTitle23: "事件同步",
      pushTabTitle24: "pure数据同步",
      pushTabTitle25: "智能数据准备",
      pushTabTitle26: "智能数据同步",
      pushTabTitle27: "算法任务生成",
      pushTabTitle28: "智能算法计算",
      pushTabTitle29: "per数据回传",
      pushTabTitle30: "白名单回传",
      pushTabTitle31: "control数据回传",
      pushTabTitle32: "pure数据回传",
      pushTabTitle33: "智能策略结果生成",
      pushTabTitle34: "智能人群数据生成",
      pushTabTitle35: "是否重置流程？",
      pushTabTitle36: "操作异常！",
      pushTabTitle37: "月数据更新",
      timeTabTitle1: "定时推送设置",
      timeTabTitle2: "确认定时推送",
      timeTabTitle3: "取消定时设置",
      timeTabTitle4: "推送时间",
      timeTabTitle5: "每日前置任务完成后",
      timeTabTitle6: "填写时间默认开启当前时间，空白时间为不开启定时推送",
      tabTitle1: "最近30天推送成功率",
      tabTitle2: "最近30天推送数据平均时长",
      tabTitle3: "最近30天推送结果校验平均时长",
      stratMsg1: "上传数据校验未成功，暂不能下载！",
      stratMsg2: "当前日期不能下载！",
      stratMsg3: "上传数据校验未成功！",
      subTabTitle1: "推送状态",
      subTabTitle2: "标签同步完成时间",
      subTabTitle3: "人群过滤完成时间",
      subTabTitle4: "上传完成时间",
      subTabTitle5: "推送完成时间",
      subTabTitle6: "推送验证完成时间",
      confirmTabTitle1: "确定推送",
      confirmTabTitle2: "数据",
      confirmTabTitle3: "此结果推送到结果库",
      confirmTabTitle4: "推送",
      stratMsg4: "取消推送操作！",
      Jan: "一月",
      Feb: "二月",
      Mar: "三月",
      Apr: "四月",
      May: "五月",
      Jun: "六月",
      Jul: "七月",
      Aug: "八月",
      Sep: "九月",
      Oct: "十月",
      Nov: "十一月",
      Dec: "十二月",
      minute: "分钟",
      resetBtn: "复 位",
      status1: "未推送",
      status2: "待推送",
      status3: "推送中",
      status4: "推送完成",
      status5: "推送失败",
    },
    uploadPackage: {
      title1: "数据分析",
      title2: "上传人群包",
      tabTitle1: "数据类型",
      tabTitle2: "点击选择文件",
      tabTitle3: "上传",
      tabTitle4: "手机号",
      tabTitle5: "或将您的文件拖放到此处",
      tabTitle6: "请选择需要上传的文件！",
      tabTitle7: "您上传了{number}个",
      tabTitle8: "手机号",
      tabTitle9: "邮件",
      tabTitle10:
        "注意：只能上传Excel、csv格式文件，支持上传手机号、member_ID、UnionID、邮箱",
      tabTitle11: "Excel模板",
      tabTitle12: "CSV文件模板",
      tabTitle13: "模板文件",
      tabTitle14: "请选择数据类型！",
    },
    MaterialTagMgmt: {
      title1: "素材管理",
      title2: "标签管理",
      title3: "标签列表",
      title4: "新建标签",
      tabTitle1: "标签名称",
      tabTitle2: "标签描述",
      tabTitle3: "标签层级",
      tabTitle4: "更新时间",
      tabTitle5: "使用次数",
      tabTitle6: "热门排名",
      tabTitle7: "操作",
      tabMsg1: "请输入需要查找的标签名称",
      reset: "重置",
      createTagLevel: "新建层级",
      editTag: "编辑标签",
      tagLvTitle1: "层级",
      tagLvTitle2: "请选择层级",
      tagLvTitle3: "标签的值",
      tagLvTitle4: "请输入标签的值",
      tagLvTitle5: "描述",
      tagLvTitle6: "请输入标签描述",
      tagLvTitle7: "层级名称",
      tagLvTitle8: "请输入层级名称",
      tagLvTitle9: "编辑层级",
      editTagSuc: "修改标签成功！",
      addTagSuc: "新增标签成功！",
      addLevelSuc: "新增层级成功！",
      editLevelSuc: "新增层级成功！",
    },
    materialUpload: {
      MaterialMgmt: "素材管理",
      UploadMaterial: "素材上传",
      materialUpload: "上传素材",
      InformationEntry: "信息填写",
      dropFileHere: "将您的文件拖放到此处",
      ChooseFileToUpload: "选择文件上传",
      All: "全选",
      MaterialName: "素材名称",
      PleaseEnterModification: "请输入需要修改成的名称",
      Smart: "智能",
      Custom: "自定义",
      Inheritance_material_file_name: "继承素材文件名",
      MaterialClassification: "素材分类",
      PleaseChooseCategory: "请选择需要修改成的分类",
      MaterialTags: "素材标签",
      PleaseSelectTags: "请选择需要修改成的标签",
      MaterialFormat: "素材格式",
      PleaseSelect: "请选择",
      ValidityPeriod: "有效期",
      to: "至",
      StartTime: "开始时间",
      EndTime: "截止时间",
      LongTermValidity: "长期有效",
      BulkSave: "批量保存",
      Upload: "上传",
      UploadSuc: "上传素材成功！",
      UploadCannotEmpty: "上传文件不能为空！",
      selectMaterialFirst: "请先勾选素材！",
    },
    materialLibrary: {
      MaterialMgmt: "素材管理",
      MaterialLibrary: "素材库",
      MaterialName: "素材名称",
      EntryMaterialName: "请输入素材名称",
      materialID: "素材ID",
      EntryMaterialID: "请输入素材ID",
      Reset: "重置",
      ClassifDisplay: "分类展示",
      PleaseSelectTag: "请选择标签",
      PleaseSelectTheType: "请选择素材类型",
      PleaseSelectStatus: "请选择状态",
      validity: "有效",
      All: "全选",
      BatchEdit: "批量编辑",
      BatchDownload: "批量下载",
      BatchDelete: "批量删除",
      ValidityPeriod: "有效期",
      downloadURL: "下载地址",
      Creator: "创建人",
      type: "类型",
      Format: "格式",
      CreationTime: "创建时间",
      download: "下载",
      DownloadStatus: "下载状态",
      ConfirmDelete: "确定删除?",
      EditMaterial: "素材编辑",
      MaterialDimensions: "素材尺寸",
      width: "宽度",
      height: "高度",
      MaintainAspectRatio: "保持纵横比",
      Preview: "预览",
      imageType: "图片格式",
      PleaseSelectMaterials: "请勾选素材！",
      ConfirmDeletingSelectedMaterials: "确认删除所选素材？",
    },
    categoryMgt: {
      MaterialMgmt: "素材管理",
      CategoryManagement: "分类管理",
      CategoryName: "分类名称",
      PleaseEnterSearch: "请输入需要查找的分类名称",
      ClassifDisplay: "分类展示",
      CategoryList: "分类列表",
      New: "新建",
      avatar: "头像",
      ClassificationDescription: "分类描述",
      ParentCategory: "上级分类",
      operation: "操作",
      // popup
      categoryEdit: "编辑分类",
      categoryCreate: "新建分类",
      tabTitle1: "上级名称",
      tabTitle2: "请选择上级名称",
      tabTitle3: "分类头像",
      tabTitle4: "分类描述",
      tabTitle5: "请输入分类描述",
      tabTitle6: "请输入分类描述名称",
    },
    materialDetail: {
      AssetDetails: "素材详情",
      BasicInformation: "基本信息",
      MaterialName: "素材名称",
      OriginalName: "原名称",
      MaterialClassification: "素材分类",
      ParentCategory: "上级分类",
      AssetInformation: "素材信息",
      materialType: "素材类型",
      MaterialFormat: "素材格式",
      MaterialDimensions: "素材尺寸",
      FileSize: "素材大小",
      OtherInformation: "其他信息",
      Uploader: "上传人员",
      UploadTime: "上传时间",
      ValidityPeriod: "有效期",
      RecentlyModified: "最近修改",
      TagInformation: "标签信息",
      NoTagsAvailable: "暂无标签",
      MaterialPerformance: "素材表现",
      Last7Days: "近7天",
      Last30Days: "近30天",
      Last90Days: "近90天",
      WebsiteTraffic: "访问量",
      DownloadCount: "下载量",
    },
    memberCenter: {
      addRules: "新增规则",
      editRules: "编辑规则",
      viewRules: "查看规则",
      pointsRules: "积分规则",
      memberCenter: "会员中心",
      memberDetail: "会员详情",
      memberList: "会员列表",
      memberCombine: "会员合并",
      combineAccount: "合并账号",
      memberPoints: "会员积分",
      individualInsight: "单体洞察",
      memberEvent: "会员事件",
      addMemberEvent: "添加会员事件",
      editMemberEvent: "编辑会员事件",
      registerGiftsConfig: "注册礼包配置",
      phone: "手机",
      phoneNumber: "手机号码",
      memberName: "会员名称",
      memberNickName: "会员昵称",
      memberID: "会员ID",
      realName: "真实姓名",
      nickName: "昵称",
      sex: "性别",
      memberSex: "会员性别",
      birthday: "生日",
      birthdayDate: "生日日期",
      email: "邮箱",
      country: "国家",
      registerTime: "注册时间",
      firstRegisterChannel: "首次注册渠道",
      buyChannel: "购买渠道",
      buyStore: "购买门店",
      subChannel: "子渠道",
      isEmployee: "是否员工",
      isTermsOfAuthorization: "是否条款授权",
      subscribeToMessageEmails: "订阅消息电子邮件",
      subscribeToNewsletters: "订阅消息邮件",
      subscribeToMessageSMS: "订阅消息短信",
      subscribeToMessagePhone: "订阅消息电话",
      addMember: "新增会员",
      editMember: "编辑会员",
      locationArea: "所在区域",
      thirdID: "ThirdID",
      presetExtensionAttr: "预设扩展属性",
      firstRegisterChannelPl: "请选择首次注册渠道",
      locationAreaPl: "请选择所在区域",
      thirdIDPl: "请输入ThirdID",
      presetExtensionAttrPl: "请输入预设扩展属性",
      phonePl: "请输入手机号码",
      memberNamePl: "请输入会员名称",
      memberNickNamePl: "请输入会员昵称",
      memberIDPl: "请输入会员ID",
      realNamePl: "请输入真实姓名",
      phoneNumberPl: "请输入手机号码",
      nickNamePl: "请输入昵称",
      sexPl: "请选择性别",
      emailPl: "请输入邮箱",
      countryPl: "请输入国家",
      birthdayPl: "请选择生日",
      pointsOverview: "积分概况",
      changelog: "变更记录",
      validCredits: "有效积分",
      yesterdayAddNewPoints: "昨日新增积分",
      yesterdaySpentPoints: "昨日消耗积分",
      pointsExchangeRate: "积分汇率",
      exchangeRateSettings: "汇率设置",
      changeTime: "变更时间",
      changeType: "变更类型",
      events: "事件",
      pointsDetail: "积分流水",
      changeReason: "变更原因",
      changeDescription: "变更描述",
      changeTimePl: "请选择变更时间",
      changeTypePl: "请选择变更类型",
      eventsPl: "请选择事件",
      changePoints: "变更积分",
      changeReasonPl: "请选择变更原因",
      changeDescriptionPl: "请输入变更描述",
      changePointsPl: "请输入变更积分",
      pointsConfig: "积分配置",
      rulesName: "规则名称",
      startAndEndDate: "起止时间",
      priority: "优先级",
      rulesStatus: "规则状态",
      rulesType: "规则类型",
      rulesNamePl: "请输入规则名称",
      startAndEndDatePl: "请选择起止时间",
      priorityPl: "请输入优先级",
      rulesStatusPl: "请选择规则状态",
      rulesTypePl: "请选择规则类型",
      rulesDescriptionPl: "请输入规则",
      basicConfig: "基础配置",
      orderLimit: "订单商品限制",
      eventName: "事件名称",
      eventKey: "事件标识",
      eventQuality: "事件性质",
      eventType: "事件类型",
      eventRemark: "事件备注",
      addEvent: "新增事件",
      tag: "标签",
      tagName: "标签名称",
      tagNamePl: "请输入标签名称",
      bindStaticTag: "绑定静态标签",
      eventNamePl: "请输入事件名称",
      eventKeyPl: "请输入事件标识",
      eventTypePl: "请选择事件类型",
      addMemberEventConfirm: "是否确认保存会员事件",
      addRuleConfirm: "是否确认保存规则",
      addBaseConfigConfirm: "是否确认保存基础配置",
      correlationEvents: "关联事件",
      correlationEventsPl: "请选择关联事件",
      limit: "限制",
      natureWeek: "自然周",
      numberOfEngagements: "参与次数",
      times: "次",
      resetConfiguration: "清零配置",
      resetRules: "清零规则",
      doNotReset: "不清零",
      naturalYearReset: "自然年清零上一年获得的积分",
      relativeValidityPeriodOfPoints: "积分相对有效期",
      expirationAfter: "后失效",
      displayCopywritingConfiguration: "展示文案配置",
      displayCopywriting: "展示文案",
      goldBean: "金豆",
      pointEventTypeConfig: "积分事件类型配置",
      pointEventLimitConfig: "积分事件商品限制配置",
      noLimit: "不限制",
      fixedTimeLimit: "固定时间限制",
      maximumObtainableWithin: "内最多可获得",
      onlyOnce: "仅赠送一次",
      points: "积分",
      give: "赠送",
      expiresAfter: "后失效",
      subtitle:
        "修改展示文案将变更积分的对外展现形式，供第三方系统调用，如展示文案为“金豆”则“800积分”展示为“800金豆”",
      subtitle1: "事件类型为“参与次数”的获取积分限制",
      subtitle2:
        "消费者符合以上条件后，配置以上规则相关的商品购买事件规则将不生效",
      subtitle3:
        "消费者在以下配置的注册渠道进行注册，即可领取配置的券包;之后再去其他渠道注册，不能重复领取",
      subtitle4: "消费者注册了账号，再注销，再重新注册，不能重复获得这个礼包",
      subtitle5: "请选择保留的账号(主账号)",
      subtitle6: "请确认以上信息，无误后点击确认进行会员合并",
      subtitle7: "符合以上条件的获得 X ",
      subtitle8: "倍 积分",
      subtitle9: "咖啡胶囊 = ",
      subtitle10: "选择咖啡胶囊",
      reservedAccount: "保留的账号(主账号)",
      mergedAccounts: "被合并的账号",
      sysEvent: "系统事件",
      customEvent: "自定义事件",
      registerChannel: "注册渠道",
      registerChannelPl: "请选择注册渠道",
      registerIssueCoupon: "注册发放渠道券",
      addConsumptionVouchers: "添加消费券",
      bindPeople: "绑定人群",
      memberIdentity: "会员身份",
      commonlyUsedAddr: "常用地址",
      masterClass: "大师课",
      reclaim: "回收",
      subscribeToMessages: "订阅消息",
      subscribeToMessagesChannel: "订阅消息渠道",
      auditRuleConfirmTitle: "确定审核",
      auditRuleConfirmContent: "确定要审核该规则？",
      auditCancelRuleConfirmTitle: "确定取消审核",
      auditCancelRuleConfirmContent: "确定要取消审核该规则？",
      runRuleConfirmTitle: "确定启动",
      runRuleConfirmContent: "确定要启动该规则？",
      pauseRuleConfirmTitle: "确定暂停",
      pauseRuleConfirmContent: "确定要暂停该规则？",
      stopRuleConfirmTitle: "确定终止",
      stopRuleConfirmContent: "确定要终止该规则？",
      deleteRuleConfirmTitle: "确定删除",
      deleteRuleConfirmContent: "确定要删除该规则？",
      bindSuccess: "绑定成功！",
      className: "课程名称",
      reservationStore: "预约门店",
      reclaimCount: "回收次数",
      currentPoints: "当前积分",
      increaseAndDecrease: "增减积分",
      logoffAccountInfo: "注销账号信息",
      logoffDesc: "注销说明",
      everyTime: "每次参与",
    },
    orderCenter: {
      order: "订单",
      orderCenter: "订单中心",
      orderType: "订单类型",
      orderList: "订单列表",
      orderStatus: "订单状态",
      orderNumber: "订单编号",
      channel: "渠道",
      shopName: "店铺名称",
      shop: "店铺",
      platformNick: "平台昵称",
      orderStatusPl: "请选择订单状态",
      orderTimePl: "请选择交易时间",
      orderNumberPl: "请输入订单编号",
      channelPl: "请选择渠道",
      shopNamePl: "请输入店铺名称",
      platformNickPl: "请输入平台昵称",
      tradeTime: "交易时间",
      tradeChannel: "订单渠道",
      merchandiseNum: "商品数量",
      orderTotal: "订单总额",
      amountPaidTotal: "实付总额",
      tradeStatus: "交易状态",
      refundOrder: "退款订单",
      refundOrderDetail: "退款订单详情",
      platformTrackingNumber: "平台单号",
      refundTrackingNumber: "退款单号",
      refundOrigin: "退款来源",
      refundStatus: "退款状态",
      refundLogID: "退款记录ID",
      refundTotal: "退款总额",
      refundStartTime: "退款发起时间",
      refundEndTime: "退款完成时间",
      confirmTime: "用户确认收款时间",
      baseInfo: "基本信息",
      refundDetail: "退款明细",
      name: "名称",
      childOrderID: "子订单ID",
      childOrderCount: "子订单个数",
      productCategory: "产品分类",
      productType: "商品类型",
      refundNum: "退款数量",
      refundAmount: "退款金额",
      baseItemCode: "基础物料编码",
      orderDetail: "订单详情",
      platformBuyerNick: "平台买家昵称",
      orderNo: "订单号",
      buyerIdentityType: "买家身份类型",
      buyerIdentityValue: "买家身份值",
      orderBrand: "订单品牌",
      orderPointsStatus: "订单积分状态",
      tradeInfo: "交易信息",
      paymentTime: "付款时间",
      discountAmount: "优惠金额",
      orderEndenTime: "订单的交易结束时间",
      paymentType: "支付类型",
      numOfSpu: "Spu数量",
      numOfSku: "Sku数量",
      buyerConfirmTime: "买家收货时间",
      refundTime: "退款时间",
      sellerShippingTime: "卖家发货时间",
      consignee: "收货人",
      orderTime: "下单时间",
      contactWay: "联系方式",
      capsulePurchaseChannel: "胶囊购入渠道",
      chooseDoorTime: "选择上门时间",
      consigneeInfo: "收货人信息",
      consigneeName: "收货人姓名",
      consigneePhone: "收货人手机号",
      consigneeRegion: "收货人所在地区",
      consigneeProvince: "收货人省份",
      consigneeCity: "收货人城市",
      shippingMethods: "配送方式",
      consigneeAddress: "收货人地址",
      consigneePostcode: "收货人邮编",
      shoppingGuideInformation: "导购信息",
      guiderID: "导购ID",
      guiderName: "导购名称",
      duties: "职务",
      storesID: "门店ID",
      storesName: "门店名称",
      storesType: "门店类型",
      belongRegion: "归属大区",
      orderDetail1: "订单明细",
      discountInfo: "优惠信息",
      materialType: "物料类型",
      materialTypePl: "请选择物料类型",
      quantityPurchased: "购买数量",
      unitPrice: "单价",
      giftCode: "礼品码",
      childOrderAmountNo: "子订单优惠金额",
      childOrderAmountTotal: "子订单应付总金额",
      childOrderActualPaymentAmount: "子订单实付金额",
      discountRemark: "优惠备注",
      discountDesc: "优惠说明",
      subtitle: "自然年内购买商品进行积分的数量 大于:",
      subtitle1: "请填写物料信息",
      subtitle2: "订阅消息方式",
      subtitle3: "提醒和订阅",
      subscription: "订阅",
    },
    couponCenter: {
      currentDay: "领取当日生效，",
      couponCenter: "卡券中心",
      couponCode: "优惠码",
      couponCodeID: "优惠码ID",
      couponCodeName: "优惠码名称",
      couponCodeType: "优惠码类型",
      couponCodeStatus: "优惠码状态",
      availability: "可领时间",
      couponCodeExpirationDate: "优惠码有效期",
      distributionTotal: "发放总量",
      claimed: "已领取",
      used: "已使用",
      couponCodePl: "请输入优惠码名称",
      couponCodeTypePl: "请选择优惠码类型",
      couponCodeStatusPl: "请选择优惠码状态",
      oneCardOneCode: "一卡一码",
      cashCouponCode: "现金券码",
      oneCardOneCodeDesc: "优惠码具有唯一性，仅可使用一次",
      addNow: "立即新建",
      coupon: "优惠券",
      couponName: "优惠券名称",
      couponType: "优惠券类型",
      couponSelectPl: "请选择优惠券",
      couponCountPl: "请填写优惠券数量",
      couponTypePl: "请选择优惠券类型",
      couponStatus: "优惠券状态",
      couponStatusPl: "请选择优惠券状态",
      couponID: "优惠券ID",
      couponIDPl: "请选择优惠券ID",
      codeType: "券码类型",
      codeTypePl: "请选择券码类型",
      claimedAndRemainder: "已领取/剩余",
      couponExpirationDate: "优惠码有效期",
      addCouponCode: "新增券码",
      addCouponCode1: "新增优惠码",
      batchDistributeCoupon: "批量发券",
      batchDistributeCouponHistory: "批量发券历史",
      distributeCouponTime: "发券时间",
      distributeCouponNumber: "发券数量",
      couponTitle1: "发券人次",
      couponTitle2: "发券失败次数",
      couponTitle3: "下载失败名单",
      baseInfo: "基础信息",
      collectionAndUsageRules: "领取和使用规则",
      subtitle1: "修改优惠券总量时只能增加不能减少请谨慎设置",
      subtitle2:
        "图片只支持jpeg,png,jpg等格式，限1个文件，图片大小不超过500 KB",
      subtitle3:
        "创建后只能在“优惠码列表-发放总量”里添加总量，不可减少总量，请谨慎设置",
      usageTime: "可用时间",
      applicableChannels: "适用渠道",
      allChannelUsage: "全部渠道可用",
      fixedChannelUsage: "指定渠道可用",
      limitClaimsPerPerson: "每人限领次数",
      title1: "每人最多领",
      title2: "每人每日最多领",
      title3: "每人每周最多领",
      title4: "每人每月最多领",
      title5: "领取后第",
      title6: "生效，",
      precautions: "使用须知",
      generateWay: "生成方式",
      automaticallyGenerated: "自动生成",
      importTheCodeLibrary: "导入码库",
      voucherName: "兑换券名称",
      dispatchCoupon: "发放优惠券",
      memberId: "会员ID",
      phoneNumber: "手机号",
      memberPhoneNumber: "会员手机号",
      usercouponCode: "券编码",
      userState: "状态",
      getTime: "领取时间",
      getChannel: "领取渠道",
      getCode: "券编码",
      stopUse: "停止用户用券",
      stopUseCode: "停止用户用码",
      stopUse2: "已停止用户用券",
      ConfirmContent: "确认停止该用户用券吗？",
      ConfirmContentCode: "确认停止该用户用码吗？",
      getUseListDetail: "领券详情",
      getUseListDetail1: "领码详情",
      codeId: "优惠码号",
      useTpye: "使用状态",
      creatTime: "创建时间",
      addTotal: "添加总量",
      addStock: "添加库存",
      editCouponCode: "编辑优惠券",
      editCouponCode1: "编辑优惠码",
      inviatationCode: "邀请码",
      campaignName: "活动名称",
      state: "状态",
      batchDistributeinviatationCode: "批量生成邀请码",
      trueName: "真实姓名",
      expirationDate: "有效期",
      useAndStock: "已使用/剩余",
      stop: "暂停",
      refresh: "恢复",
      addinviatationCode: "生成邀请码",
      addinviatationCodeConfirm: "确认生成邀请码",
      detailInviatationCode: "邀请码详情",
    },
    openApi: {
      openApi: "开放接口",
      signManagement: "签名管理",
      viewApi: "查看API",
      signKey: "签名Key",
      signKeyPl: "请输入签名Key",
      addSign: "新增签名",
      signSecret: "签名密钥",
      signSecretPl: "请输入签名密钥",
      channelName: "渠道名称",
      wechatAppID: "微信AppID",
      wechatAppIDPl: "请输入微信AppID",
      channelNamePl: "请输入渠道名称",
      callbackAddress: "回调地址",
      callbackAddressPl: "请输入回调地址",
      updateInfo: "更新信息",
      updateSecret: "更新密钥",
      authorizationApi: "授权API",
      authorizationOpenApi: "可授权OpenAPI",
      requestAddress: "请求地址",
      requestAddressPl: "请输入请求地址",
      requestMethod: "请求方式",
      requestMethodPl: "请选择请求方式",
      requestHeader: "请求头",
      requestHeaderPl: "请输入请求头",
      belongModule: "所属模块",
      belongModulePl: "请选择所属模块",
      apiDocument: "接口文档",
      inputParameter: "输入参数",
      inputParameterPl: "请输入输入参数",
      outputParameter: "输出参数",
      outputParameterPl: "请输入输出参数",
      linkDesc: "链接描述",
      belongChannel: "所属渠道",
      belongChannelPl: "请选择所属渠道",
      whitelistIP: "白名单IP",
      leader: "负责人",
      sendExpertSms: "发送企业专家短信",
      marketingCenter: "营销中心",
      radioText1: "Open Api Member Coupon Controller 计算金额",
      radioText2: "Open Api Member Coupon Controller 锁定",
      radioText3: "Open Api Member Coupon Controller 通过优惠码领码",
      radioText4: "Tag Controller会员标签列表",
      radioText5: "Tag Controller详情",
      radioText6: "删除标签",
      radioText7: "绑定标签",
      radioText8: "解绑标签",
      radioText9: "Tag Group Controller群组详情",
      radioText10: "删除人群",
      radioText11: "null会员属性字段",
      radioText12: "创建/更新订单",
      radioText13: "会员详情",
      radioText14: "会员渠道账号绑定",
      radioText15: "会员渠道账号更新会员渠道信息",
      radioText16: "订单详情",
      tagCenter: "标签中心",
    },
    metadata: {
      metadata: "元数据",
      metadataManagement: "元数据管理",
      dimensionInfoManagement: "维度信息管理",
      title1:
        "消费者在以下配置的注册渠道进行注册，即可领取配置的券包;之后再去其他渠道注册，不能重复领取",
      title2: "消费者注册了账号，再注销，再重新注册，不能重复获得这个礼包",
      title3: "导入说明",
      title4: "下载导入模板",
      title5: "上传导入文件",
      desc1: "用于基础物料的咖啡机类型和积分字段导入",
      desc2: "导入为全量导入，已有咖啡的咖啡机类型和积分将被覆盖",
      desc3: "咖啡机类型/积分为空，则该咖啡机/积分不进行导入",
      desc4: "咖啡机积分如需设置为0，请在模板中积分列输入为0",
      desc5: "请上传xlsx文件",
      addCustomerRoles: "添加客户身份",
      editCustomerRoles: "编辑客户身份",
      identityName: "身份名称",
      identityType: "身份类型",
      identityCode: "身份标识",
      identityManagement: "身份管理",
      channelManagement: "渠道管理",
      storeManagement: "门店管理",
      basicMaterialManagement: "基础物料管理",
      isUnique: "是否唯一",
      priority: "优先级",
      inheritance: "随迁性",
      channelName: "渠道名称",
      brand: "品牌",
      platform: "平台",
      addChannel: "添加渠道",
      editChannel: "编辑渠道",
      channelCode: "渠道code",
      description: "描述",
      belongBrand: "所属品牌",
      belongPlatform: "所属平台",
      defaultIdentityCode: "默认身份标识",
      storeName: "门店名称",
      branchStoreName: "分店名称",
      addStore: "添加门店",
      editStore: "编辑门店",
      storeNo: "门店编号",
      storeAddress: "门店地址",
      storePhone: "门店电话",
      longitude: "经度",
      latitude: "纬度",
      syncStore: "同步门店",
      locationArea: "所在区域",
      detailAddress: "详细街道地址",
      coffeeMakerTypeImport: "咖啡机类型导入",
      coffeeMakerType: "咖啡机类型",
      coffeeMakerTypeAndPointsImport: "咖啡机类型&积分导入",
      basicMaterialName: "基础物料名称",
      basicMaterialCode: "基础物料编码",
      materialType: "物料类型",
      basicMaterialNamePl: "请输入基础物料名称",
      basicMaterialCodePl: "请输入基础物料编码",
      brandName: "品牌名称",
      syncBasicMaterial: "同步基础物料",
      exportList: "导出列表",
      buyPoints: "购买积分",
      retailPrice: "零售价",
      getStoreListPage: "获取门店列表分页",
    },

    blackAndWhiteList: {
      title1: "智能沟通",
      title2: "适用策略",
      title3: "全部策略",
      title4: "部分策略",
      title5: "长期",
      title6: "自定义",
      title7: "继续新增",
      title8: "错误原因",
      title9: "继续编辑",
      title10: "文件总条数",
      title11: "下载错误报告",
      title12: "导入完成",
      title13: "导入失败",
      title14: "文件总数",
      title15: "成功导入",
      title16: "失败条数",

      placeholder2: "请选择适用策略",
      blackAndWhiteList: "黑白名单",
      blackAndWhiteListManagement: "黑白名单管理",
      addList: "新增名单",
      editList: "编辑名单",
      viewList: "查看名单",
      importList: "导入名单",
      downloadTemplate: "下载模板",
      listName: "名单名称",
      listType: "名单类型",
      listTypePl: "请选择名单类型",
      listType1: "黑名单",
      listType2: "白名单",
      confirmTip: "确定删除该名单？",
    },
  },
};
